export default function parseCoveragesInCard(coverages, groups) {
  let coveragesToShow = [];
  coverages.forEach(coverage => {
        if(coverage["view_status"] != "2") return

        
        let group_id = coverage["group_id"]
        
        if(group_id == false) group_id = "False"
        coverage["priority_calculated"] = groups[group_id.toString()]? ((groups[group_id.toString()]["priority"] + 1) * 1000) + coverage["priority"] : 10000
        
        coveragesToShow.push(coverage)
  });
  coveragesToShow.sort((x, y) => x.priority_calculated - y.priority_calculated);
  return coveragesToShow
}
